import m from './module';

/**
 * Formula calculation service
 */

class RecapFormulaCalculationService {

  evaluate(formula, currentValuesByFieldId = null) {
    return this.calculate(formula, currentValuesByFieldId);
  }

  calculate(formula, currentValuesByFieldId = null) {
    if ("operator" in formula) {
      const operand1 = this.calculate(formula.operand1, currentValuesByFieldId);
      const operand2 = this.calculate(formula.operand2, currentValuesByFieldId);
      switch (formula.operator) {
        case "+":
          return operand1 + operand2;
        case "-":
          return operand1 - operand2;
        case "*":
          return operand1 * operand2;
        case "/":
          return operand2 === 0 ? 0 : operand1 / operand2;
        default:
          return 0;
      }
    } else if ("value" in formula) {
      switch (formula.value.type) {
        case "unit": {
          const unit = parseFloat(formula.value.unit);
          return Number.isNaN(unit) ? 0 : unit;
        }
        case "item":
          return this.getCurrentValueForFieldString(formula.value.item.value, currentValuesByFieldId, formula.value.item.aggregate);
      }
    }
    return 0;
  }

  getFieldIdFromFieldString(fieldString) {
    // fieldString looks like "field_12345"
    const fieldStringParts = fieldString.split('_');
    return (fieldStringParts && fieldStringParts.length === 2) ? parseInt(fieldStringParts[1]) : null;
  }

  getCurrentValueForFieldString(fieldString, currentValuesByFieldId = null, aggregateType = null) {
    let value = 0;
    const fieldId = this.getFieldIdFromFieldString(fieldString);
    if (fieldId && currentValuesByFieldId && (fieldId in currentValuesByFieldId)) {
      let values = currentValuesByFieldId[fieldId].map(v => parseFloat(v));
      if (values.length > 0) {
        switch (aggregateType) {
          case 'sum':
            value = values.reduce((total, curr) => total + curr, 0);
            break;
          case 'average':
          case 'avg':
          case 'mean':
          default:
            let sum = values.reduce((total, curr) => total + curr, 0);
            value = sum / values.length;
            break;
          case 'min':
            value = values.reduce((min, curr) => min === null ? curr : (curr < min ? curr : min), null);
            break;
          case 'max':
            value = values.reduce((max, curr) => max === null ? curr : (curr > max ? curr : max), null);
            break;
        }
      }
    }
    return value;
  }

  getFieldIdsReferencedInFormula(formula) {
    let referencedFieldIds = [];
    if ('operator' in formula) {
      const allReferencedFieldIds = [
        ...this.getFieldIdsReferencedInFormula(formula.operand1),
        ...this.getFieldIdsReferencedInFormula(formula.operand2),
      ];
      // Ensure they are unique
      referencedFieldIds = allReferencedFieldIds.filter((val, idx, arr) => arr.indexOf(val) === idx);
    } if ('value' in formula) {
      switch (formula.value.type) {
        case 'unit':
          break;
        case 'item':
          const fieldId = this.getFieldIdFromFieldString(formula.value.item.value);
          referencedFieldIds = [fieldId];
          break;
      }
    }
    return referencedFieldIds;
  }
}

export default RecapFormulaCalculationService;

m.service('RecapFormulaCalculationService', RecapFormulaCalculationService);
